import Text from '@mui/material/Typography'

function Refunds() {
   return (
      <div>
         <div style={{marginTop:10, marginBottom:100}}><Text variant='h6'>Refund Policy</Text></div>
      </div>
   )
}
export default Refunds